export default __webpack_public_path__ + "static/media/read_write1.32848625.png";